import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  DateField,
  DateTimeInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  SelectArrayInput,
  SimpleFormIterator,
  ArrayInput,
  TextField,
  ReferenceField,
  ReferenceFieldController,
  Filter,
  required,
  SimpleShowLayout,
  Show,
  ArrayField,
  ReferenceArrayField,
  SingleFieldList,
} from 'react-admin'
import {
  AssessmentField,
  AssessmentSelect,
  ClassSelect,
  FullNameField,
  getFullName,
} from '../components/selects'

import { cloneElement } from 'react'

import { Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/AddCircleOutline'
// import { useAssessmentIds } from '../utils/useCourseIds'

const StringToLabelObject = ({ record, children, ...rest }) =>
  cloneElement(children, {
    record: { label: record },
    ...rest,
  })

const ListBase = (props) => {
  // const assessment_ids = useAssessmentIds()
  return (
    <List
      filters={<InstanceFilter />}
      // filter={assessment_ids ? { assessment_id: assessment_ids } : null}
      sort={{ field: 'date', order: 'ASC' }}
      perPage={25}
      {...props}
    >
      <AssessmentInstanceList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <AssessmentInstanceShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <AssessmentInstanceForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <AssessmentInstanceForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const InstanceFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    {/* <CourseSelect alwaysOn /> */}
    <AssessmentSelect alwaysOn />
    <ClassSelect alwaysOn />
  </Filter>
)

const AssessmentInstanceList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <DateField
      showTime
      options={{ hour12: false }}
      source="date"
      label="Date of Instance"
    />

    <ReferenceField
      label="Assessment Performed"
      source="assessment_id"
      reference="assessments"
    >
      <TextField source="name" />
    </ReferenceField>

    <ReferenceFieldController
      label="Course"
      reference="assessments"
      source="assessment_id"
    >
      {({ referenceRecord }) => (
        <ReferenceField
          basePath="/"
          reference="courses"
          source="course_id"
          record={referenceRecord || {}}
        >
          <TextField source="name" />
        </ReferenceField>
      )}
    </ReferenceFieldController>

    <ReferenceField
      label="Class"
      source="student_group_id"
      reference="student_groups"
    >
      <TextField source="name" />
    </ReferenceField>
  </Datagrid>
)

const AssessmentInstanceShow = (props) => (
  <SimpleShowLayout {...props}>
    <AssessmentField />
    <DateField
      showTime
      options={{ hour12: false }}
      source="date"
      label="Scheduled Date & Time"
      fullWidth
    />
    <DateField
      showTime
      options={{ hour12: false }}
      label="Date Performed"
      source="started_at"
      fullWidth
    />
    <ReferenceField
      fullWidth
      allowEmpty={false}
      label="Instance Started By"
      source="started_by"
      reference="users"
    >
      <FullNameField />
    </ReferenceField>
    <ArrayField label="Flights" source="lanes">
      <Datagrid>
        <ReferenceArrayField
          label="Instructors"
          source="instructors"
          reference="users"
          perPage={100}
        >
          <SingleFieldList>
            <FullNameField />
          </SingleFieldList>
        </ReferenceArrayField>

        <ArrayField label="Fire Teams" source="teams">
          <SingleFieldList>
            <StringToLabelObject>
              <ReferenceArrayField
                label="Participants"
                reference="students"
                source="label"
                style={{ margin: '0 8px 8px 0' }}
              >
                <SingleFieldList>
                  <FullNameField style={{ margin: '0 0 8px 0' }} />
                </SingleFieldList>
              </ReferenceArrayField>
            </StringToLabelObject>
          </SingleFieldList>
        </ArrayField>
      </Datagrid>
    </ArrayField>
  </SimpleShowLayout>
)

const AssessmentInstanceForm = (props) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <ReferenceInput
      fullWidth
      allowEmpty={false}
      label="Assessment"
      source="assessment_id"
      reference="assessments"
      perPage={100}
      style={{
        width: '50%',
        paddingRight: 20,
        boxSizing: 'border-box',
        display: 'inline',
        float: 'left',
      }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>

    <DateTimeInput
      source="date"
      label="Scheduled Date & Time"
      fullWidth
      style={{
        width: '50%',
        boxSizing: 'border-box',
        display: 'inline',
        float: 'left',
      }}
    />
    <DateTimeInput
      label="Date Performed"
      source="started_at"
      fullWidth
      style={{
        width: '50%',
        paddingRight: 20,
        boxSizing: 'border-box',
        display: 'inline',
        float: 'left',
      }}
    />
    <ReferenceInput
      fullWidth
      allowEmpty={false}
      perPage={100}
      label="Instance Started By"
      source="started_by"
      reference="users"
      style={{
        width: '50%',
        display: 'inline',
        float: 'left',
      }}
    >
      <SelectInput optionText={getFullName} />
    </ReferenceInput>

    <ArrayInput validate={[test]} label="Flights" source="lanes">
      <SimpleFormIterator
        addButton={<LabelButton label="Add Flight" {...props} />}
      >
        <ReferenceArrayInput
          fullWidth
          allowEmpty={false}
          validate={[required()]}
          perPage={100}
          label="Instructors"
          source="instructors"
          reference="users"
        >
          <SelectArrayInput optionText={getFullName} />
        </ReferenceArrayInput>

        <ArrayInput validate={[required()]} label="Fire Teams" source="teams">
          <SimpleFormIterator
            addButton={<LabelButton label="Add Fire Team" {...props} />}
          >
            <ReferenceArrayInput
              fullWidth
              validate={[required()]}
              allowEmpty={false}
              perPage={100}
              label="Participants"
              reference="students"
            >
              <SelectArrayInput optionText={getFullName} />
            </ReferenceArrayInput>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleFormIterator>
    </ArrayInput>
  </SimpleForm>
)

const test = (value, allValues) => {
  const flat = value
    ?.map((t) => [...(t?.instructors || []), ...(t?.teams || [])])
    .flat(3)

  if (hasDuplicates(flat)) {
    return 'Flights contain duplicate users'
  }

  return []
}

const LabelButton = ({ label = 'Add', ...props }) => {
  return (
    <Button {...props}>
      <AddIcon style={{ marginRight: 8 }} />
      {label}
    </Button>
  )
}

export const hasDuplicates = (arr = []) => new Set(arr).size !== arr.length
